/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TranslateJsonDto } from '../../models/translate-json-dto';
import { TranslateJsonResponseDto } from '../../models/translate-json-response-dto';

export interface AutomaticTranslationControllerTranslateJson$Params {
  
    /**
     * JSON file to be translated
     */
    body: TranslateJsonDto
}

export function automaticTranslationControllerTranslateJson(http: HttpClient, rootUrl: string, params: AutomaticTranslationControllerTranslateJson$Params, context?: HttpContext): Observable<StrictHttpResponse<TranslateJsonResponseDto>> {
  const rb = new RequestBuilder(rootUrl, automaticTranslationControllerTranslateJson.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TranslateJsonResponseDto>;
    })
  );
}

automaticTranslationControllerTranslateJson.PATH = '/automatic-translation/translate-json';
